<script setup>
	import { defineProps } from 'vue'

	const props = defineProps({
		item: Object,
		required: true
	})

</script>

<template>
	<div class="promotion">
		<div class="w-[100%] relative after:content-[''] after:pt-[70%] after:block">
	      <img 
	        v-lazy="{ 
	          src: item.image, 
	          loading: 'img/image_loader.gif', 
	          error: 'img/no_image.png' 
	        }" 
	      />
	    </div>
	    <div class="flex items-center m-3">
	    	<h2>{{ item.title }}</h2>
	    	<a
	          :href="`https://www.google.com/maps?q=${item.lat},${item.lng}`"
	          target="_blank"
	          rel="noopener"
	        >
	        	<img class="w-5 h-5 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" src="img/location.png"/>
	        </a>
		</div>
		<p>{{ item.description }}</p>
	</div>
</template>

<style scoped>
	/*
    **PROMOTION CARD
    */
    .promotion {
        @apply bg-white dark:bg-zinc-700 mx-2 my-2 rounded-3xl grow shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50;
    }
    .promotion > div > img {
       @apply absolute top-0 left-0 w-full h-full object-cover rounded-t-3xl;
    }

    .promotion h2 {
        @apply text-sm font-semibold grow;
    }

    .promotion p {
        @apply text-sm text-zinc-400 mx-3 mt-1 mb-3;
    }

    .promotion a {
        @apply rounded-full w-7 h-7 shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 bg-[var(--color)] block ms-1 shrink-0 relative; 
    }

</style>